

import React from 'react';
import { Icon } from '../../../../../../../../ui-kit';
import { SubOptionBlock, RecipientElement } from '../../Blocks/components/common/StyledEditables';






const RecipientBlock = (
{ addRecipientName }) =>
{
  const addContent = (e, type) => {
    e.stopPropagation();
    if (addRecipientName) {
      addRecipientName(e, type);
    }
  };

  return (
    <SubOptionBlock>
      <RecipientElement onClick={(e) => addContent(e, 'recipient')}>
        <span>Recipient Name</span>
        <Icon name="addfat" color="black" size={16} />
      </RecipientElement>
      <RecipientElement onClick={(e) => addContent(e, 'company')}>
        <span>Company Name</span>
        <Icon name="addfat" color="black" size={16} />
      </RecipientElement>
    </SubOptionBlock>);

};
export default RecipientBlock;